import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Injectable, ViewChild, HostListener, ViewContainerRef, ComponentFactoryResolver } from "@angular/core";
import { delay, SharedService, FeedbackStatusEnum } from '../shared';
import { CannabisSection } from '../medizinisches-cannabisantrag/shared';
import { CannabisJSON } from '../medizinisches-cannabisantrag/data';
import { SplitComponent, SplitAreaDirective } from 'angular-split'
import Grid from 'tui-grid';


@Component({
    selector: 'app-antrag-feedback',
    templateUrl: "./antrag-feedback.component.html",
    styleUrls: ["./antrag-feedback.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class AntragFeedbackComponent implements OnInit {
    @ViewChild("feedbackSplitter", { static: false }) feedbackSplitter: SplitComponent;

    showLoading: boolean = false;
    inputPassword: string = "";
    showForm: boolean = false;
    loginError: boolean = false;

    updateStatus: boolean = false;

    CannabisJSON: CannabisSection[] = CannabisJSON;

    statusList: any = [
        { name: 'New', value: FeedbackStatusEnum.New },
        { name: 'Read', value: FeedbackStatusEnum.Read },
        { name: 'Approved', value: FeedbackStatusEnum.Approved },
        { name: 'Done', value: FeedbackStatusEnum.Done },
        { name: 'Rejected', value: FeedbackStatusEnum.Rejected },
        { name: 'Archived', value: FeedbackStatusEnum.Archived }
    ];

    statusChangeList: any = [
        { name: 'Read', value: FeedbackStatusEnum.Read },
        { name: 'Approved', value: FeedbackStatusEnum.Approved },
        { name: 'Done', value: FeedbackStatusEnum.Done },
        { name: 'Rejected', value: FeedbackStatusEnum.Rejected },
        { name: 'Archived', value: FeedbackStatusEnum.Archived }
    ];

    sectionList: any = [];

    selectedStatus = FeedbackStatusEnum.New;
    selectedSection = 0;

    feedbackData: any = [];
    feedbackGrid: Grid;
    feedbackDetail: any = null;

    get fullYear() {
        return new Date().getFullYear();
    }

    get formMainBlock() {
        if (document.getElementById("form-main-block")) {
            return document.getElementById("form-main-block").clientHeight;
        } else {
            return window.innerHeight;
        }
    }

    get formGroupBlock() {
        if (document.getElementById("form-group-block")) {
            return document.getElementById("form-group-block").clientHeight;
        } else {
            return 134;
        }
    }

    get contentHeight() {
        return this.formMainBlock - this.formGroupBlock - 10;
    }

    get gridBodyHeight() {
        return this.contentHeight - 44;
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        //this.fnContinueToForm();
        this.bindingSectionList();
        this.windowEvents();
    }

    windowEvents() {
        window["viewFeedbackDetail"] = (rowKey) => {
            this.fnViewFeedbackDetail(rowKey);
        }

        window["onkeydown"] = (e) => {
            if (!this.feedbackGrid || !this.showForm) {
                return;
            }
            const focused = this.feedbackGrid.getFocusedCell();
            const row = this.feedbackGrid.getRow(focused.rowKey);

            if (e.keyCode == '38') {
                // up arrow
                if (!row && this.feedbackGrid.getData().length > 0) {
                    this.feedbackGrid.focus(0, "section");
                }
                if (!row) {
                    return;
                }
                if (this.feedbackDetail) {
                    this.fnViewFeedbackDetail(focused.rowKey);
                }
            }
            else if (e.keyCode == '40') {
                // down arrow
                if (!row && this.feedbackGrid.getData().length > 0) {
                    this.feedbackGrid.focus(0, "section");
                }
                if (!row) {
                    return;
                }
                if (this.feedbackDetail) {
                    this.fnViewFeedbackDetail(focused.rowKey);
                }
            }
            else if (e.keyCode == '37') {
                // left arrow
                this.fnHideFeedbackDetail();
            }
            else if (e.keyCode == '39') {
                // right arrow
                if (!row) {
                    return;
                }
                this.fnViewFeedbackDetail(focused.rowKey);
            }
            else if (e.keyCode == '32') {
                // space
                if (!row) {
                    return;
                }
                if (row._attributes.checked) {
                    this.feedbackGrid.uncheck(focused.rowKey);
                } else {
                    this.feedbackGrid.check(focused.rowKey);
                }
            }
        }
    }

    async fnHideFeedbackDetail() {
        this.feedbackDetail = null;
        await delay(1);
        this.fnUpdateFeedbackGrid();
    }

    fnViewFeedbackDetail(rowKey) {
        var allData = this.feedbackGrid.getData();
        var rowData = allData.find(a => a.rowKey == rowKey);
        this.feedbackDetail = rowData;
        if (rowData) {
            this.bindSummarySplitFn();
            this.updateFeedbackStatus(rowData.id as number, FeedbackStatusEnum.Read, false);
        }
    }

    async bindSummarySplitFn() {
        this.feedbackSplitter.dragProgress$.subscribe(res => {
            this.fnUpdateFeedbackGrid();
        })
        await delay(1);
        this.fnUpdateFeedbackGrid();
    }

    bindingSectionList() {
        var displayNumber = 0;
        for (var p = 0; p < CannabisJSON.length; p++) {
            const section = CannabisJSON[p];
            for (var i = 0; i < section.questions.length; i++) {
                const question = section.questions[i];
                displayNumber = this.sharedService.getQuestionNumber(section, question, p, i, displayNumber);
            }
        }

        this.sectionList.push({ name: 'All', value: 0 });
        for (var i = 1; i <= displayNumber; i++) {
            this.sectionList.push({ name: `Question ${i}`, value: i });
        }
    }

    async fnValidatePassword() {
        if (!this.sharedService.PythonAPIUrl) {
            await delay(100);
            this.fnValidatePassword();
            return;
        }
        this.showLoading = true;
        this.loginError = false;
        this.sharedService.validateEditorialPassword(this.inputPassword).subscribe(
            res => {
                if (res) {
                    this.fnContinueToForm();
                } else {
                    this.fnShowLoginError();
                }
            },
            err => {
                this.fnShowLoginError();
            }
        )
    }

    errorTimer: any;
    async fnShowLoginError() {
        this.showLoading = false;
        this.loginError = true;
        clearTimeout(this.errorTimer);
        this.errorTimer = setTimeout(() => {
            this.loginError = false;
        }, 5000);

    }

    fnContinueToForm() {
        this.showLoading = false;
        this.showForm = true;
        this.cd.detectChanges();
        this.fnGetFeedbackData();
    }

    fnSearchData() {
        this.feedbackDetail = null;
        this.fnGetFeedbackData();
    }

    async fnGetFeedbackData() {
        if (!this.sharedService.PythonAPIUrl) {
            await delay(100);
            this.fnGetFeedbackData();
            return;
        }

        this.sharedService.getFeedbackData(this.selectedStatus, this.selectedSection).subscribe(
            res => {
                this.feedbackData = res || [];
                this.fnUpdateFeedbackGrid(true);
            },
            err => {
                this.feedbackData = [];
                this.fnUpdateFeedbackGrid(true);
            }
        )
    }

    fnUpdateFeedbackGrid(resetData = false) {
        if (this.feedbackGrid) {
            const focused = this.feedbackGrid.getFocusedCell();
            this.feedbackGrid.setBodyHeight(this.gridBodyHeight);
            if (resetData) {
                this.feedbackGrid.resetData(this.feedbackData);
            }
            this.feedbackGrid.refreshLayout();
            if (focused && parseInt(focused.rowKey.toString())>= 0) {
                this.feedbackGrid.focus(focused.rowKey, "section", true);
            }
        } else {
            this.initializeGrid();
        }
    }

    getStatusName(value) {
        const status = this.statusList.find(a => a.value === value);
        return status ? status.name : value;
    }

    formatDate(date) {
        return new Date(date).toLocaleString()
    }

    async initializeGrid() {
        await delay(100);
        let component = this;
        this.feedbackGrid = new Grid({
            el: document.getElementById('feedbackGrid'), // Container element
            data: this.feedbackData,
            bodyHeight: component.gridBodyHeight,
            //rowHeight: 'auto',
            header: {
                align: 'left',
                columns: [
                    {
                        name: 'note',
                        align: 'center'
                    }
                ]
            },
            columnOptions: {
                resizable: true
            },
            columns: [
                {
                    header: 'Section',
                    name: 'section',
                    width: 85,
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    },
                    sortable: true
                },
                {
                    header: 'Status',
                    name: 'status',
                    width: 120,
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${component.getStatusName(props.value)}">${component.getStatusName(props.value)}</span>` : "";
                    },
                    sortable: true
                },
                {
                    header: 'Type',
                    name: 'type',
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    },
                    sortable: true
                },
                {
                    header: 'SubSection',
                    name: 'subSection',
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    },
                    sortable: true
                },
                {
                    header: 'Created',
                    name: 'created',
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${component.formatDate(props.value)}">${component.formatDate(props.value)}</span>` : "";
                    },
                    sortable: true
                },
                {
                    header: 'Note',
                    name: 'note',
                    width: 85,
                    align: 'center',
                    filter: 'text',
                    sortable: false,
                    resizable: false,
                    formatter: function (props) {
                        return `<button type="button" class="btn btn-sm btn-outline-primary" style="line-height: 1;padding: 2px 5px;">
                                        <img src="/view.svg" style="width:16px;" alt="View" />
                                    </button>`;
                    }
                }
            ]
        });

        this.feedbackGrid.on("click", (data) => {
            this.fnViewFeedbackDetail(data["rowKey"]);
        })


        this.feedbackGrid.activateFocus();

        Grid.applyTheme('striped');
    }

    onChangeFeedback() {
        if (this.feedbackDetail) {
            const Id = parseInt(this.feedbackDetail.id);
            const Status = parseInt(this.feedbackDetail.status);
            this.updateFeedbackStatus(Id, Status, true);
        }
    }


    updateFeedbackStatus(Id: number, Status: FeedbackStatusEnum, update: boolean) {
        const index = this.feedbackData.findIndex(a => a.id === Id);
        if (index > -1) {
            const record = this.feedbackData[index];
            if (record && record.status === FeedbackStatusEnum.New && Status === FeedbackStatusEnum.Read) {
                update = true;
            }
        }

        if (update) {
            this.sharedService.updateFeedbackStatus(Id, Status).subscribe(
                res => {
                    this.feedbackData[index].status = Status;
                    this.fnUpdateFeedbackGrid(true);
                    if (this.feedbackDetail) {
                        this.feedbackDetail.status = Status;
                    }
                    this.fnUpdateStatus();
                }
            )
        }
    }

    async fnUpdateStatus() {
        this.updateStatus = true;
        await delay(1);
        this.updateStatus = false;

    }


    s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    downloadExcel() {
        var OrderBy = "";
        var Ascending = true;
        if (this.feedbackGrid) {
            const sortState = this.feedbackGrid.getSortState();
            var columnName = sortState.columns[0].columnName;
            if (columnName === 'section' || columnName === 'status' || columnName === 'type' || columnName === 'created' || columnName ==='subSection') {
                OrderBy = columnName;
                Ascending = sortState.columns[0].ascending;
            }
        }
        this.sharedService.downloadFeedbackExcel(this.selectedStatus, this.selectedSection, OrderBy, Ascending).subscribe(
            res => {
                if (res) {
                    var blob = new Blob([this.s2ab(atob(res.fileContents))], {
                        type: res.contentType
                    });

                    var href = URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = href;
                    a.download = res.fileDownloadName;
                    a.click();
                    a.remove();
                }
            }
        )
    }

}
